var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgIllustrationVoucherClaimed = function SvgIllustrationVoucherClaimed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__a)",
    fillRule: "evenodd",
    d: "m111.344 102.123.121-.113a6.465 6.465 0 0 0-.121.113m.121-.113c.661-.595 1.492-1.019 2.452-1.27.291-.073.606-.146.922-.17l2.5-2.33a5.494 5.494 0 0 0-.834.15l-.089.02c-1.019.267-1.893.752-2.572 1.383zm17.281 32.271 2.477-2.309c-.409.378-.935.662-1.555.829l-2.5 2.33c.631-.17 1.165-.461 1.578-.85m-97.468-30.847 2.455-2.288c-1.392 1.32-1.593 3.77-.32 6.22l-2.112 1.969 2.088-1.945 5.679 10.873-2.5 2.33-5.655-10.898c-1.286-2.475-1.067-4.926.364-6.261m2.5-2.33-.045.042zM50.45 135.81l-1.528 1.424 4.392 8.478c1.674 3.204 5.266 5.267 8.009 4.563l-2.5 2.33c-2.743.704-6.335-1.359-8.01-4.563l.017-.015-4.579-8.795 2.5-2.33.088.171c1.447-2.24 1.45-5.593-.307-8.981-2.524-4.83-7.693-7.985-11.965-7.499l2.5-2.33c4.272-.51 9.465 2.67 11.965 7.499 2.063 3.981 1.7 7.912-.582 10.048m10.873 14.465 68.344-17.474-2.5 2.305-68.32 17.499z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__b)",
    d: "M103.675 82.804c2.742-.704 6.334 1.359 8.009 4.563l5.655 10.897a5.65 5.65 0 0 0-.923.17c-4.417 1.14-5.824 6.237-3.13 11.431 2.694 5.194 8.446 8.446 12.887 7.329.315-.072.607-.169.874-.291l4.587 8.81c1.674 3.204.776 6.407-1.942 7.111l-68.32 17.475c-2.742.704-6.334-1.359-8.009-4.563l-4.587-8.81c3.738-1.553 4.805-6.31 2.281-11.14-2.524-4.83-7.693-7.985-11.965-7.499l-5.655-10.898c-1.674-3.203-.776-6.407 1.942-7.111z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "illustration-voucher-claimed_svg__d",
    width: 101,
    height: 69,
    x: 32,
    y: 82,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__c)",
    d: "M103.675 82.804c2.742-.704 6.334 1.359 8.009 4.563l5.655 10.897a5.65 5.65 0 0 0-.923.17c-4.417 1.14-5.824 6.237-3.13 11.431 2.694 5.194 8.446 8.446 12.887 7.329.315-.072.607-.169.874-.291l4.587 8.81c1.674 3.204.776 6.407-1.942 7.111l-68.32 17.475c-2.742.704-6.334-1.359-8.009-4.563l-4.587-8.81c3.738-1.553 4.805-6.31 2.281-11.14-2.524-4.83-7.693-7.985-11.965-7.499l-5.655-10.898c-1.674-3.203-.776-6.407 1.942-7.111z"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-voucher-claimed_svg__e)",
    mask: "url(#illustration-voucher-claimed_svg__d)",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4EDFF",
    d: "m133.893 121.983-93.926-27.23 26.066-24.028 47.327-3.641 29.561 33.493z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__f)",
    d: "m77.022 50.328 2.155-3.88-23.566-13.206-2.095 3.792c-.02.03-.043.057-.06.089-.018.033-.03.068-.045.103l-.013.023.002.001c-.729 1.861 3.683 6.148 10.042 9.711 6.507 3.648 12.587 5.155 13.58 3.368z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__g)",
    d: "M79.177 46.451c.993-1.787-3.478-6.192-9.985-9.839-6.508-3.646-12.588-5.154-13.58-3.367-.993 1.787 3.478 6.192 9.985 9.839 6.508 3.646 12.588 5.154 13.58 3.367"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 8.742,
    d: "M76.885 45.883c-1.366-.062-3.63-.74-6.46-2.014-5.538-2.49-11.226-6.358-12.84-8.722-.093-1.293 2.904-.915 7.474 1.083 5.35 2.341 10.797 6 12.162 8.17.528.839.369 1.33-.336 1.483Z",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__h)",
    d: "M76.885 45.882c.705-.154.864-.645.336-1.484-1.364-2.17-6.811-5.829-12.161-8.17-4.57-1.998-7.569-2.376-7.474-1.083-.028-.04-.056-.078-.08-.117-1.073-1.868 1.874-2.21 7.553.349 5.676 2.555 11.733 6.38 12.925 8.866.47.977.09 1.57-1.1 1.639z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__i)",
    d: "M76.885 45.883c-1.366-.062-3.63-.74-6.46-2.014-5.538-2.49-11.226-6.358-12.84-8.722-.093-1.293 2.904-.915 7.474 1.083 5.35 2.341 10.797 6 12.162 8.17.528.839.369 1.33-.336 1.483"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__j)",
    fillRule: "evenodd",
    d: "m70.095 50.554-.141-.132c.048.044.095.087.141.132m-.141-.132c-.77-.693-1.736-1.185-2.853-1.478a6.553 6.553 0 0 0-1.073-.198l-2.91-2.71c.334.025.643.097.971.173l.103.024c1.186.31 2.203.875 2.994 1.61zm-20.11 37.554-2.883-2.687c.477.44 1.09.77 1.81.965l2.91 2.71c-.735-.197-1.356-.536-1.836-.988M163.27 52.08l-2.857-2.663c1.619 1.537 1.853 4.388.372 7.238l2.592 2.416-2.564-2.388-6.609 12.653 2.909 2.712 6.581-12.681c1.497-2.881 1.242-5.734-.424-7.287m-2.909-2.711.052.048zm-19.403 40.387 1.777 1.657-5.11 9.867c-1.949 3.728-6.129 6.128-9.32 5.309L48.771 86.253l2.91 2.683 79.504 20.364-2.877-2.708 2.905 2.708c3.191.819 7.371-1.582 9.32-5.31l-.019-.018 5.329-10.234-2.909-2.712-.103.2c-1.683-2.608-1.686-6.51.357-10.452 2.937-5.62 8.953-9.292 13.924-8.727l-2.909-2.711c-4.971-.593-11.015 3.106-13.924 8.727-2.401 4.632-1.977 9.207.678 11.692",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__k)",
    d: "M79.02 28.073c-3.192-.82-7.372 1.581-9.32 5.31l-6.581 12.68c.367.029.734.113 1.073.198 5.14 1.328 6.778 7.259 3.643 13.303-3.135 6.044-9.828 9.828-14.997 8.53a5.368 5.368 0 0 1-1.017-.34l-5.338 10.252c-1.948 3.728-.903 7.457 2.26 8.276l79.504 20.335c3.192.819 7.372-1.582 9.321-5.31l5.338-10.252c-4.35-1.808-5.593-7.344-2.655-12.964 2.937-5.62 8.953-9.292 13.924-8.727l6.58-12.681c1.949-3.728.904-7.456-2.259-8.275z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__l)",
    d: "m43.788 157.162 3.158-3.263-19.787-19.294-3.074 3.192c-.028.023-.058.045-.084.071-.026.028-.049.06-.072.09l-.018.02.001.001c-1.213 1.646 2.01 7.051 7.35 12.257 5.464 5.329 11.072 8.429 12.527 6.926z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__m)",
    d: "M46.945 153.901c1.454-1.502-1.797-7.04-7.26-12.367-5.465-5.328-11.073-8.429-12.527-6.927-1.455 1.503 1.796 7.04 7.26 12.368 5.464 5.328 11.072 8.429 12.527 6.926"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 8.925,
    d: "M44.832 152.733c-1.333-.423-3.391-1.693-5.85-3.702-4.812-3.928-9.408-9.258-10.376-12.021.25-1.303 3.112-.135 7.098 3.051 4.666 3.731 9.079 8.789 9.852 11.295.3.97.012 1.412-.724 1.377Z",
    opacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__n)",
    d: "M44.83 152.731c.738.036 1.025-.407.726-1.377-.773-2.506-5.187-7.564-9.852-11.295-3.987-3.186-6.849-4.353-7.098-3.05-.018-.047-.036-.093-.048-.138-.566-2.13 2.436-1.687 7.37 2.346 4.932 4.028 9.904 9.414 10.423 12.186.205 1.09-.327 1.576-1.52 1.328"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__o)",
    d: "M44.832 152.733c-1.333-.423-3.391-1.693-5.85-3.702-4.812-3.928-9.408-9.258-10.376-12.021.25-1.303 3.112-.135 7.098 3.051 4.666 3.731 9.079 8.789 9.852 11.295.3.97.012 1.412-.724 1.377"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__p)",
    d: "m150.991 117.229-1.41-4.207-25.646 8.488 1.386 4.104c.008.034.013.07.025.104.012.036.03.069.046.103l.008.026.002-.001c.883 1.793 7.022 1.428 13.943-.862 7.082-2.344 12.297-5.815 11.647-7.754z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__q)",
    d: "M149.583 113.024c-.65-1.938-6.917-1.609-13.999.735-7.082 2.344-12.296 5.815-11.647 7.753.65 1.938 6.917 1.609 13.999-.734 7.082-2.344 12.296-5.816 11.647-7.754"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 8.742,
    d: "M147.617 114.333c-.967.966-2.996 2.18-5.845 3.409-5.574 2.409-12.266 3.999-15.1 3.595-1.018-.803 1.283-2.76 5.841-4.786 5.337-2.37 11.712-3.923 14.235-3.467.976.176 1.231.625.869 1.249Z",
    opacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__r)",
    d: "M147.617 114.332c.362-.624.107-1.072-.869-1.249-2.523-.457-8.897 1.096-14.235 3.466-4.557 2.027-6.859 3.985-5.84 4.787-.049-.006-.096-.011-.141-.021-2.103-.466-.367-2.873 5.352-5.34 5.715-2.465 12.625-4.357 15.265-3.56 1.037.313 1.22.993.467 1.917z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__s)",
    d: "M147.617 114.333c-.967.966-2.996 2.18-5.845 3.409-5.574 2.409-12.266 3.999-15.1 3.595-1.018-.803 1.283-2.76 5.841-4.786 5.337-2.37 11.712-3.923 14.235-3.467.976.176 1.231.625.869 1.249"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__t)",
    d: "m34.806 96.687 3.088-1.194c3.868-1.527 5.832-7.257 4.087-14.449-1.903-7.848-7.228-13.894-12.167-13.823-.46.007-1.868.404-2.25.541l-3.5 1.347z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__u)",
    d: "M35.125 96.578c4.443-1.679 5.714-9.255 2.838-16.922-2.875-7.667-8.808-12.522-13.251-10.843-4.443 1.68-5.714 9.256-2.838 16.923 2.875 7.667 8.808 12.521 13.251 10.842"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__v)",
    d: "M34.085 93.09c-.367.172-.766.259-1.206.266h-.049c-1.606 0-3.767-.764-5.512-2.68-1.945-2.135-3.442-4.997-4.217-8.06-.964-3.816-.388-7.683 1.117-9.557.63-.784 1.393-1.171 2.331-1.184-.416.196-.787.502-1.122.917-1.505 1.874-2.081 5.74-1.117 9.556.774 3.063 2.272 5.926 4.217 8.061 1.744 1.915 3.906 2.68 5.512 2.68h.047z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__w)",
    d: "M35.209 92.172c-.335.416-.708.721-1.125.917h-.046c-1.607 0-3.768-.765-5.513-2.68-1.944-2.135-3.442-4.997-4.216-8.061-.965-3.815-.39-7.682 1.117-9.556.334-.415.706-.72 1.122-.917h.048c1.607 0 3.528 1.098 5.273 3.012 1.945 2.135 3.443 4.999 4.216 8.061.964 3.816.628 7.35-.877 9.224z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__x)",
    d: "m154.08 67.402 3.264 2.279c4.119 2.832 11.118.931 17.068-5.655 6.493-7.188 8.895-16.577 5.497-21.458-.317-.456-1.659-1.593-2.052-1.882l-3.693-2.586-20.084 29.303z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__y)",
    d: "M173.089 59.086c5.658-8.036 6.47-17.229 1.813-20.532-4.657-3.304-13.019.533-18.677 8.569-5.659 8.036-6.47 17.229-1.813 20.533 4.657 3.303 13.019-.534 18.677-8.57"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__z)",
    d: "M157.159 64.258a3.495 3.495 0 0 1-1.077-1.024l-.034-.049c-1.082-1.602-1.78-4.276-1.059-7.308.805-3.38 2.632-6.802 5.146-9.64 3.13-3.532 7.349-5.563 10.219-5.324 1.202.1 2.099.601 2.743 1.53-.474-.283-1.027-.449-1.664-.503-2.871-.241-7.09 1.79-10.22 5.323-2.514 2.837-4.34 6.26-5.145 9.64-.723 3.032-.025 5.705 1.058 7.309l.031.046z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-voucher-claimed_svg__A)",
    d: "M158.826 64.762c-.638-.053-1.192-.22-1.667-.505l-.031-.046c-1.082-1.603-1.781-4.277-1.058-7.308.805-3.38 2.631-6.803 5.145-9.64 3.13-3.534 7.35-5.564 10.22-5.324.637.054 1.189.22 1.665.502l.033.049c1.082 1.602 1.288 4.262.568 7.293-.805 3.38-2.633 6.803-5.146 9.638-3.131 3.534-6.858 5.58-9.729 5.34z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-voucher-claimed_svg__B)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.479,
    cy: 166.616,
    fill: "#E9E7F6",
    rx: 68.25,
    ry: 9.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__a",
    x1: 95.216,
    x2: 108.718,
    y1: 90.641,
    y2: 150.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__b",
    x1: 82.535,
    x2: 82.535,
    y1: 82.666,
    y2: 150.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#9FBCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__c",
    x1: 82.535,
    x2: 82.535,
    y1: 82.666,
    y2: 150.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#9FBCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__f",
    x1: 61.179,
    x2: 71.093,
    y1: 30.783,
    y2: 53.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A305"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__g",
    x1: 62.943,
    x2: 71.868,
    y1: 29.753,
    y2: 49.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__h",
    x1: 63.922,
    x2: 71.621,
    y1: 30.982,
    y2: 48.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A305"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__i",
    x1: 63.943,
    x2: 71.248,
    y1: 31.892,
    y2: 48.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2DDB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__j",
    x1: 88.863,
    x2: 73.151,
    y1: 37.192,
    y2: 107.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F65E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#AEEA73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__k",
    x1: 103.619,
    x2: 103.619,
    y1: 27.912,
    y2: 106.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#9FBCFF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEEA73",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__l",
    x1: 33.312,
    x2: 37.167,
    y1: 133.646,
    y2: 158.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A305"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__m",
    x1: 35.327,
    x2: 38.798,
    y1: 133.096,
    y2: 155.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__n",
    x1: 35.969,
    x2: 38.963,
    y1: 134.568,
    y2: 153.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A305"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__o",
    x1: 35.751,
    x2: 38.592,
    y1: 135.472,
    y2: 153.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2DDB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__p",
    x1: 125.876,
    x2: 149.115,
    y1: 115.741,
    y2: 123.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A305"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__q",
    x1: 126.305,
    x2: 147.226,
    y1: 113.745,
    y2: 120.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__r",
    x1: 127.873,
    x2: 145.92,
    y1: 113.85,
    y2: 119.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A305"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__s",
    x1: 128.558,
    x2: 145.681,
    y1: 114.448,
    y2: 120.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2DDB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__t",
    x1: 24.064,
    x2: 42.623,
    y1: 81.954,
    y2: 81.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A305"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__u",
    x1: 20.336,
    x2: 39.508,
    y1: 82.695,
    y2: 82.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__v",
    x1: 22.628,
    x2: 34.085,
    y1: 82.617,
    y2: 82.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A305"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__w",
    x1: 23.836,
    x2: 36.63,
    y1: 82.481,
    y2: 82.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2DDB2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__x",
    x1: 180.743,
    x2: 162.762,
    y1: 38.828,
    y2: 68.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5A305"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__y",
    x1: 151.387,
    x2: 177.929,
    y1: 53.098,
    y2: 53.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCEED6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__z",
    x1: 154.695,
    x2: 173.098,
    y1: 52.577,
    y2: 52.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5A305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-voucher-claimed_svg__A",
    x1: 174.223,
    x2: 158.916,
    y1: 40.812,
    y2: 61.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F0E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2DDB2"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-voucher-claimed_svg__e",
    width: 109.621,
    height: 61.565,
    x: 36.633,
    y: 63.751,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7395_29448",
    stdDeviation: 1.667
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-voucher-claimed_svg__B",
    width: 156.977,
    height: 38.677,
    x: 20.991,
    y: 147.277,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_7395_29448",
    stdDeviation: 5.119
  })))));
};
var Memo = /*#__PURE__*/memo(SvgIllustrationVoucherClaimed);
export default Memo;